export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7767.56fffc17.jpg";